import React from "react";

export default function PullToRefreshHeader({ height = 0, refreshing = false, ready = false }) {
  const show = height > 0 || refreshing;

  return (
    <div
      style={{
        width: "100%",
        height: show ? height : 0,
        opacity: show ? 1 : 0,
        transition: refreshing ? "none" : "height 160ms ease, opacity 160ms ease",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: 6,
      }}
      aria-hidden="true"
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, transform: "translateY(-4px)" }}>
        <span
          aria-label="Atualizando"
          style={{
            width: 26,
            height: 26,
            borderRadius: 999,
            border: "3px solid rgba(255,255,255,0.22)",
            borderTopColor: "rgba(255,255,255,0.95)",
            animation: "finbotSpin 0.85s linear infinite",
            display: "inline-block",
          }}
        />
        <span style={{ fontSize: 12, opacity: 0.7 }}>
          {refreshing ? "Atualizando…" : ready ? "Solte para atualizar" : "Puxe para atualizar"}
        </span>
      </div>

      <style>{`
        @keyframes finbotSpin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
